<template>
  <section class="hero is-white is-fullheight">
    <div class="hero-body" style="padding: 10px;">
      <div class="container">
        <div class="columns is-centered is-vcentered">
          <div class="column is-4 has-text-centered">
            <figure class="image" style="margin: 0 auto; height: auto; width: 100px;">
              <img src="/assets/img/logo-new-200.png"/>
            </figure>
          </div>
        </div>

        <div class="columns is-centered is-vcentered">
          <div class="column is-8 has-text-centered">
            <h1 class="title is-1" v-if="statusCode == 404" style="font-weight: bold;">{{ statusCode }}</h1>
            <h1 class="title">
              <span v-if="statusCode == 404 || statusCode == 403">Halaman tidak ditemukan</span>
              <span v-else-if="statusCode == 401">Silakan muat ulang/refresh halaman Anda atau login kembali</span>
              <span v-else>Sepertinya Anda tidak terhubung ke internet</span>
            </h1>
            <h2 class="subtitle is-6">
              <span v-if="statusCode == 404 || statusCode == 403">Halaman yang anda cari mungkin telah dihapus atau untuk sementara tidak tersedia</span>
              <span v-else-if="statusCode == 401">Silakan muat ulang/refresh halaman Anda atau login kembali</span>
              <span v-else>Silakan periksa kembali jaringan internet anda dan pastikan lancar</span>
            </h2>

            <div>
              <a v-if="statusCode == 401" href="" @click.prevent="clearAuth" class="button is-primary">Muat Ulang</a>
              <a v-else href="" class="button is-primary">Muat Ulang</a>
            </div>
          </div>
        </div>

        <div class="columns is-centered is-vcentered" style="margin-bottom: -35px; margin-top: -35px;">
          <div class="column is-5 has-text-centered">
            <figure class="image" style="margin: 0 auto;">
              <img src="/assets/img/404.gif" alt="">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LOGIN_MIXIN from '~/mixins/login'

export default {
  layout: 'empty',
  name: 'nuxt-error',
  props: ['error'],
  mixins: [LOGIN_MIXIN],
  head () {
    return {
      title: this.statusCode == 404 || this.statusCode == 403 ? 'Halaman tidak ditemukan' : 'Sepertinya Anda tidak terhubung ke internet',
      meta: [
        {
          name: 'viewport',
          content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
        }
      ]
    }
  },

  // Only on debug mode
  data () {
    return {
      mounted: false
    }
  },
  mounted () {
    this.mounted = true
  },
  watch: {
    error(newErr) {
      if(newErr) {
        console.error(newErr)
      }
    }
  },

  computed: {
    statusCode () {
      return (this.error && this.error.statusCode) || 500
    },
    message () {
      return this.error.message || 'Error'
    }
  },

  methods: {
    clearAuth() {
      this.$cookies.remove('token');
      window.location.href = '/login';
    }
  }
}
</script>

<style>
.__nuxt-error-page {
  padding: 1rem;
  background: #F7F8FB;
  color: #47494E;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: sans-serif;
  font-weight: 100 !important;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.__nuxt-error-page .error {
  max-width: 450px;
}
.__nuxt-error-page .title {
  font-size: 1.5rem;
  margin-top: 15px;
  color: #47494E;
  margin-bottom: 8px;
}
.__nuxt-error-page .description {
  color: #7F828B;
  line-height: 21px;
  margin-bottom: 10px;
}
.__nuxt-error-page a {
  color: #7F828B !important;
  text-decoration: none;
}
.__nuxt-error-page .logo {
  position: fixed;
  left: 12px;
  bottom: 12px;
}
</style>
